module.exports = __webpack_public_path__ + "static/img/health3.4d9d123.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/championscity/challenge/health3.png
// module id = yQVm
// module chunks = 1